module.exports = __webpack_public_path__ + "img/pro_detail_2.2cba3466.jpg";